import { render, staticRenderFns } from "./categoryDialog.vue?vue&type=template&id=37c787c0&scoped=true"
import script from "./categoryDialog.vue?vue&type=script&lang=js"
export * from "./categoryDialog.vue?vue&type=script&lang=js"
import style0 from "./categoryDialog.vue?vue&type=style&index=0&id=37c787c0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c787c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37c787c0')) {
      api.createRecord('37c787c0', component.options)
    } else {
      api.reload('37c787c0', component.options)
    }
    module.hot.accept("./categoryDialog.vue?vue&type=template&id=37c787c0&scoped=true", function () {
      api.rerender('37c787c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/inflowShopManagement/components/categoryDialog.vue"
export default component.exports